var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 6.9194C20.1666 7.5244 19.6716 8.0194 19.0666 8.0194H2.93325C2.32825 8.0194 1.83325 7.5244 1.83325 6.9194V6.91023C1.83325 4.81107 3.52909 3.11523 5.62825 3.11523H16.3624C18.4616 3.11523 20.1666 4.82023 20.1666 6.9194ZM1.83325 10.4962V15.0887C1.83325 17.1879 3.52909 18.8837 5.62825 18.8837H16.3624C18.4616 18.8837 20.1666 17.1787 20.1666 15.0796V10.4962C20.1666 9.89123 19.6716 9.39623 19.0666 9.39623H2.93325C2.32825 9.39623 1.83325 9.89123 1.83325 10.4962ZM7.33325 15.8129H5.49992C5.12409 15.8129 4.81242 15.5012 4.81242 15.1254C4.81242 14.7496 5.12409 14.4379 5.49992 14.4379H7.33325C7.70908 14.4379 8.02075 14.7496 8.02075 15.1254C8.02075 15.5012 7.70908 15.8129 7.33325 15.8129ZM13.2916 15.8129H9.62492C9.24908 15.8129 8.93742 15.5012 8.93742 15.1254C8.93742 14.7496 9.24908 14.4379 9.62492 14.4379H13.2916C13.6674 14.4379 13.9791 14.7496 13.9791 15.1254C13.9791 15.5012 13.6674 15.8129 13.2916 15.8129Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.656dc306cae9225befc16fdf2fceffc4.svg";
export { ForwardRef as ReactComponent };